
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"9","viewBox":"0 0 5 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.248 8.64a.362.362 0 01-.24-.08.326.326 0 01-.096-.24v-.64c0-.139.021-.245.064-.32.043-.085.117-.181.224-.288l2.416-2.336L1.2 2.4a1.402 1.402 0 01-.224-.272.754.754 0 01-.064-.336v-.64c0-.096.032-.17.096-.224a.326.326 0 01.4-.048.6.6 0 01.192.112L4.688 4c.096.096.16.187.192.272a.79.79 0 01.08.256v.416a.79.79 0 01-.08.256.801.801 0 01-.192.272L1.6 8.48a1.002 1.002 0 01-.192.128.428.428 0 01-.16.032z","fill":"currentColor"}})])
          )
        }
      }
    